import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {QuestionnaireService} from './questionnaireService';
import {ApiService} from '../api.service';
import {CommonService} from '../common.service';

@Component({
  selector: 'app-questionnaire',
  templateUrl: './app-questionnaire.component.html',
  styleUrls: ['./app-questionnaire.component.css']
})
export class AppQuestionnaireComponent implements OnInit, AfterViewInit {
  @Input() isShowQuestionnaire: boolean; //问卷是否弹出
  @Input() learningPathMetaId: any; //learningPathMetaId
  @Input() enter: number; //入口标签

  @Output() onExit = new EventEmitter<any>(); //关闭问卷


  questionnaireService: QuestionnaireService; //问卷Service
  questionnaireTitle: string = ""; //问卷标题
  questionnaireScoreArray: any = []; //问卷评级数组
  questionnaireTagArray: any = []; //问卷标签数组
  questionnaireLevel: number = 0; //问卷等级
  questionnaireHeadPhotoUrlArray: any = []; //问卷头像数组
  questionnaireContext: string = ""; //调查问卷内容
  selectedTag: string = ""; //用户选择的标签
  placeholder: string = ""; //textarea的placeholder
  postData: any = {}; //传递的数据
  isOpenMessage: boolean = false; //是否弹出提示
  isDisabled:boolean = false; //是否置灰
  tipMessage:string = ""; //提示内容
  buttonTheme: any = {
    'position':'bottom',
    'fontSize': 'fontSize15',
    'buttonElem':[
      {
        'color': 'blue',
        'text': '提交反馈',
        'className': 'inlineBlockRadiusBtn'
      },
      {
        'color': 'cancel',
        'text': '残忍拒绝',
        'className': 'inlineBlockRadiusBtn'
      }
    ]

  }; //按钮主题



  constructor(private apiService: ApiService,
              private commonService: CommonService) {}

  ngOnInit() {
    this.questionnaireService = new QuestionnaireService(this.apiService);
    this.commonService.removeStorage("inputContext");
    // 初始化问卷
    this.questionnaireOnInit();
  }

  ngAfterViewInit(){

  }

  // 初始化问卷
  questionnaireOnInit(){
    this.questionnaireService.getQuestionnaireContent().subscribe(result=>{
      this.questionnaireTitle = this.getQuestionnaireTitle(result);
      this.questionnaireScoreArray = this.getQuestionnaireScoreArray(result);
      this.questionnaireTagArray = this.getQuestionnaireTag(result);
      this.questionnaireHeadPhotoUrlArray = this.getQuestionnaireHeadPhotoUrl(result);
      this.placeholder = this.questionnaireDataFormatting(result, 2)[0].description;
    })
  }

  // 满意度数据分类格式化
  questionnaireDataFormatting(questionnaire,type){
    return questionnaire.filter(a => a.type == type);
  }

  // 获取问卷标题
  getQuestionnaireTitle(questionnaire){
    return this.questionnaireDataFormatting(questionnaire, 1)[0].description;
  }

  //获取问卷评级
  getQuestionnaireScoreArray(questionnaire){
    return this.questionnaireDataFormatting(questionnaire, 2).filter(d => d.level!==0 );
  }

  // 获取问卷头像
  getQuestionnaireHeadPhotoUrl(questionnaire){
    return this.questionnaireDataFormatting(questionnaire, 4);
  }

  //获取打分模块回传的等级
  getQuestionnaireLevel(data){
    this.questionnaireLevel = data+1;
    this.placeholder = this.questionnaireScoreArray[this.questionnaireLevel-1].description;
  }

  //获取问卷标签
  getQuestionnaireTag(questionnaire){
    return this.questionnaireDataFormatting(questionnaire, 3);
  }

  // 获取回传的标签
  getSelectedTag(data){
    this.selectedTag = data;
  }

  //获取调查问卷内容
  getQuestionnaireContext(data){
    this.questionnaireContext = data;
  }

  //打开提示
  openMessageBox(){
    this.isOpenMessage = true;
    setTimeout(()=>{
      this.isOpenMessage = false;
    },1500)
  }

  //提交反馈
  commitQuestionnaire(){
    if(this.questionnaireLevel === 0){
      this.tipMessage = "请对英跃进行评分";
      this.openMessageBox();
    }else{
      this.isDisabled = true;
      this.postData['learningPathMetaId'] = this.learningPathMetaId;
      this.postData['star'] = this.questionnaireLevel;
      this.postData['context'] = this.questionnaireContext;
      if(this.enter === 1){
        this.postData['isShow'] = 1;
      }
      console.log(this.questionnaireContext);

      // 如果用户网络在线提交反馈，否则弹出提示并关闭问卷
      if(window.navigator.onLine){
        this.questionnaireService.saveUserQuestionnaireInfo(this.postData).then(result=>{
          if(result){
            this.tipMessage = "谢谢你的反馈！";
            this.openMessageBox();
            this.onExit.emit();
          }
        }).catch(error=>{
          this.tipMessage = error.error.msg;
          this.openMessageBox();
          setTimeout(()=>{
            this.onExit.emit();
          }, 2000);
        })
      }else{
        this.tipMessage = "网络不稳定，阻碍了提交的脚步。可以稍后再试一次吗？";
        this.openMessageBox();
        setTimeout(()=>{
          this.onExit.emit();
        }, 2000);
      }

    }
  }

  //残忍拒绝
  closeQuestionnaire(){
    this.postData['learningPathMetaId'] = this.learningPathMetaId;
    this.postData['star'] = -1;
    this.postData['context'] = null;
    if(this.enter === 1){
      this.postData['isShow'] = 1;
    }

    this.questionnaireService.saveUserQuestionnaireInfo(this.postData);

    this.onExit.emit();

  }


}



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/app-questionnaire.component.ts